export default __webpack_public_path__ + "static/media/AgriCool.fc912da8.png";